import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../assets/logo_black.png";
import { BoxArrowRight, Gear, House } from "react-bootstrap-icons";
import { auth } from "../firebase"; // Firebase auth import
import { signOut } from "firebase/auth"; // Firebase signOut method

interface SidebarProps {
  showSidebar?: string;
}

const Sidebar: React.FC<SidebarProps> = ({ showSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation(); // to track the current route
  const [active, setActive] = useState<string>("");

  useEffect(() => {
    // Set the active route when the location changes
    setActive(location.pathname);
  }, [location]);

  // Helper function to apply active class to button
  const isActive = (path: string) => {
    return active === path ? true : false; // Returns true if active
  };

  // Custom styles for active button
  const activeStyle = {
    backgroundColor: "#8B0A6C", // Custom background color for active
    color: "white", // Ensure the text is readable
  };

  // Handle Logout
  const handleLogout = async () => {
    // Show confirmation alert before logging out
    const isConfirmed = window.confirm("Are you sure you want to logout?");
  
    if (!isConfirmed) {
      // If user cancels, exit the function
      return;
    }
  
    // Clear user data from localStorage
    localStorage.removeItem("loggedInUser"); // Clear the stored login state
    localStorage.removeItem("adminCredentials"); // Clear the stored login state    
  
    // Sign out from Firebase
    try {
      await signOut(auth); // Firebase sign-out
      // Redirect to login page after logout
      navigate("/"); // You can change this path to your desired route after logout
    } catch (error) {
      console.error("Error logging out:", error);
      // You can add a toast or alert here for errors during logout if needed
    }
  };
  

  return (
    <div
      className={`sidebar bg-dark text-white d-flex flex-column overflow-auto ${
        showSidebar === "show" ? "show" : ""
      }`}
    >
     <div className="sidebar-header d-flex justify-content-between align-items-start p-3">
  <div className="d-flex align-items-start">
  <img src={Logo} alt="Invoicely Pro" className="sidebar-logo" />

    {/* <img src={Logo} alt="Invoicely Pro" className="sidebar-logo" style={{ width: '50px', height: '50px' }} /> Increased logo size */}
    {showSidebar === "show" && (
      <div className="ms-2"> {/* Added margin start for spacing */}
        <h4 className="mb-0" style={{ paddingLeft: 5 }}>
          Invoicely Pro
        </h4>
        <small style={{ fontSize: '0.8rem', paddingLeft: 5 }}>Admin Login</small> {/* Small text with adjusted font size */}
      </div>
    )}
  </div>
</div>


      <div className="sidebar-menu flex flex-col gap-2 p-4 bg-gray-900 text-white h-full w-64">
        <Button
          variant="outline"
          className={`p-3 rounded-lg d-flex align-items-center ${
            isActive("/dashboard")
              ? "bg-[#8B0A6C]"
              : "bg-gray-800"
          } ${isActive("/dashboard") ? "hover:bg-[#A61C85]" : "hover:bg-yellow-500"}`}
          onClick={() => navigate("/dashboard")}
          style={{
            paddingLeft: showSidebar === "full" ? "20px" : "15px",
            color: "#ffffff",
            ...(isActive("/dashboard") ? activeStyle : {}),
            transition: "background-color 0.3s ease",
          }}
        >
          {showSidebar === "full" && <House className="me-2" />}
          {showSidebar === "full" && "Dashboard"}
          {showSidebar !== "full" && <House />}
          <span style={{ paddingLeft: 10 }}>Dashboard</span>
        </Button>

        <Button
          variant="outline"
          className={`sidebar-btn p-3 rounded-lg d-flex align-items-center ${
            isActive("/settings")
              ? "bg-[#8B0A6C]"
              : "bg-gray-800"
          } ${isActive("/settings") ? "hover:bg-[#A61C85]" : "hover:bg-yellow-500"}`}
          onClick={() => navigate("/settings")}
          style={{
            paddingLeft: showSidebar === "full" ? "20px" : "15px",
            color: "#ffffff",
            ...(isActive("/settings") ? activeStyle : {}),
            transition: "background-color 0.3s ease",
          }}
        >
          {showSidebar === "full" && <Gear className="me-2" />}
          {showSidebar === "full" && "Settings"}
          {showSidebar !== "full" && <Gear />}
          <span style={{ paddingLeft: 10 }}>Settings</span>
        </Button>

        <Button
          variant="outline"
          className={`sidebar-btn logout-btn p-3 rounded-lg d-flex align-items-center ${
            isActive("/") ? "bg-[#8B0A6C]" : "bg-gray-800"
          } ${isActive("/") ? "hover:bg-[#A61C85]" : "hover:bg-yellow-500"}`}
          onClick={handleLogout}
          style={{
            paddingLeft: showSidebar === "full" ? "20px" : "15px",
            color: "#ffffff",
            ...(isActive("/") ? activeStyle : {}),
            transition: "background-color 0.3s ease",
          }}
        >
          {showSidebar === "full" && <BoxArrowRight className="me-2" />}
          {showSidebar === "full" && "Logout"}
          {showSidebar !== "full" && <BoxArrowRight />}
          <span style={{ paddingLeft: 10 }}>Logout</span>
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
